module.exports = __webpack_public_path__ + "img/11-red-diamond.5a4fdd95.png";